import { IconProps } from "../../utils/global-types/global-types";

const ClockIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-5 h-5"}
      {...rest}
    >
      <g clipPath="url(#clip0_2000_32611)">
        <g clipPath="url(#clip1_2000_32611)">
          <path
            fill="currentColor"
            d="M9 18c4.97 0 9-4.03 9-9s-4.03-9-9-9-9 4.03-9 9 4.03 9 9 9M8.357 3.857c0-.353.29-.643.643-.643s.643.29.643.643v4.834l2.973 2.379a.643.643 0 0 1-.803 1.003L8.598 9.5A.65.65 0 0 1 8.358 9z"
          ></path>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2000_32611">
          <path fill="#fff" d="M0 0h18v18H0z"></path>
        </clipPath>
        <clipPath id="clip1_2000_32611">
          <path fill="#fff" d="M0 0h18v18H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default ClockIcon;
